const textMapping = {
  COMMON: {
    PAGE_FORBIDDEN_FOR_GUEST: {
      'zh-TW': '此頁面訪客無訪問權限，請先登入',
      en: 'Current page is forbidden to guest, please login first.',
    },
    PAGE_FORBIDDEN_FOR_CURRENT_USER: {
      'zh-TW': '您無權限讀取此頁面，請洽相關管理人員',
      en: 'You have no permission for current page, please ask related manager.',
    },
    REDIRECT_TO_LOGIN_IN_FIVE_SECONDS: {
      'zh-TW': '五秒後協助跳轉至登入頁面',
      en: 'Redirect to login page in five seconds.',
    },
    UNKNOWN_ERROR: {
      'zh-TW': '發生錯誤，請稍後再試。如持續發生請與我們聯絡',
      en: 'Oops, something wrong! Please contact us if problem keeps occur.',
    },
    RESOURCE_NOT_FOUND: {
      'zh-TW': '找不到相關資源，請確認連結正確或與我們聯絡',
      en: 'Resource not found. Please check your link or contact us.',
    },
    QUICK_EDIT: {
      'zh-TW': '快速編輯',
      en: 'Quick Edit',
    },
    EDIT: {
      'zh-TW': '編輯',
      en: 'Edit',
    },
    VIEW: {
      'zh-TW': '檢視',
      en: 'View',
    },
    CREATE: {
      'zh-TW': '新建',
      en: 'Create',
    },
    ADD: {
      'zh-TW': '加入',
      en: 'Add',
    },
    UPDATE: {
      'zh-TW': '更新',
      en: 'Update',
    },
    CANCEL: {
      'zh-TW': '取消',
      en: 'Cancel',
    },
    DELETE: {
      'zh-TW': '刪除',
      en: 'Delete',
    },
    DELETE_CONFIRM: {
      'zh-TW': '確定刪除',
      en: 'Delete Confirm',
    },
    REMOVE: {
      'zh-TW': '移除',
      en: 'Remove',
    },
    CLOSE: {
      'zh-TW': '關閉',
      en: 'Close',
    },
    BACK: {
      'zh-TW': '返回',
      en: 'Back',
    },
    PROCESSING: {
      'zh-TW': '處理中',
      en: 'Processing',
    },
    LOADING: {
      'zh-TW': '讀取中',
      en: 'Loading',
    },
    SWITCH_LANG: {
      'zh-TW': '切換語言',
      en: 'Switch Lang',
    },
    NONE: {
      'zh-TW': '無',
      en: 'None',
    },
    PLEASE_LOGIN_FIRST: {
      'zh-TW': '請先登入',
      en: 'Please Login First',
    },
  },
  FORM: {
    PLEASE_SELECT: {
      'zh-TW': '請選擇',
      en: 'Please Select',
    },
    CLEAN_UP: {
      'zh-TW': '清空',
      en: 'Clean Up',
    },
    REPLACE: {
      'zh-TW': '更換',
      en: 'Replace',
    },
    PRE_STEP: {
      'zh-TW': '上一步',
      en: 'Pre Step',
    },
    NEXT_STEP: {
      'zh-TW': '下一步',
      en: 'Next Step',
    },
    UNSAVED_CONTENT_EXIST: {
      'zh-TW': '有尚未儲存之改動',
      en: 'Unsaved content exist',
    },
    EDIT_MODE: {
      'zh-TW': '編輯模式',
      en: 'Edit Mode',
    },
    SUGGEST: {
      'zh-TW': '推薦',
      en: 'Suggest',
    },
    REGISTER: {
      'zh-TW': '註冊',
      en: 'Register',
    },
    UPLOAD: {
      'zh-TW': '上傳',
      en: 'Upload',
    },
    ERROR: {
      IS_REQUIRED: {
        'zh-TW': '為必填',
        en: 'is required',
      },
      DUPLICATE: {
        'zh-TW': '重複',
        en: 'Duplicate',
      },
    },
  },
  SUCCESS: {
    UPDATE: {
      'zh-TW': '更新成功',
      en: 'Update Successfully',
    },
    CREATE: {
      'zh-TW': '新建成功',
      en: 'Create Successfully',
    },
    ADD: {
      'zh-TW': '新建成功',
      en: 'Add Successfully',
    },
    UPLOAD: {
      'zh-TW': '上傳成功',
      en: 'Upload Successfully',
    },
    DELETE: {
      'zh-TW': '刪除成功',
      en: 'Delete Successfully',
    },
    REGISTER: {
      'zh-TW': '註冊成功',
      en: 'Register Successfully',
    },
  },
  ERROR: {
    WRONG_INPUT: {
      'zh-TW': '輸入錯誤',
      en: 'Wrong Value',
    },
    ALL_COLUMNS_REQUIRED: {
      'zh-TW': '所有欄位皆為必填',
      en: 'All Columns are required',
    },
  },
  PLAYER: {
    REGISTER: {
      'zh-TW': '註冊',
      en: 'Register',
    },
  },
  TEAM: {
    WORDING: {
      'zh-TW': '球隊',
      en: 'Team',
    },
    STAFF: {
      'zh-TW': '行政人員',
      en: 'Staff',
    },
    PLAYER: {
      'zh-TW': '球員',
      en: 'Player',
    },
    NAME: {
      'zh-TW': '隊名',
      en: 'Name',
    },
    CITY: {
      'zh-TW': '所在縣市',
      en: 'Located City',
    },
    CITY_DENY_IN_TOURN_HINT: {
      'zh-TW': '非球隊管理者不得更新所屬縣市',
      en: 'Can not update city when you are not team manager',
    },
    UNREGISTER: {
      'zh-TW': '註銷',
      en: 'Unregister',
    },
    UNREGISTER_CONFIRM: {
      'zh-TW': '確定註銷',
      en: 'Unregister Confirm',
    },
    UNREGISTER_HINT: {
      'zh-TW': '球隊相關資料無法回復，請輸入隊名後點擊註銷按鈕',
      en: 'Team related data will be unarchived. Type team name then click unregister button.',
    },
    UNREGISTER_SUCCESS: {
      'zh-TW': '註銷成功',
      en: 'Successfullt Unregister',
    },
  },
  GAME: {
    WORDING: {
      'zh-TW': '比賽',
      en: 'Match',
    },
    SIDEBAR: {
      BACK: {
        'zh-TW': '返回',
        en: 'Back',
      },
      OVERVIEW: {
        'zh-TW': '概覽',
        en: 'Overview',
      },
      SCORE_BOARD: {
        'zh-TW': '計分板',
        en: 'Score Board',
      },
      MEDIA: {
        'zh-TW': '花絮',
        en: 'Media',
      },
      NEWS: {
        'zh-TW': '報導',
        en: 'NEWS',
      },
      RELATED_LINKS: {
        'zh-TW': '相關連結',
        en: 'Related Links',
      },
      AWAY_STATS: {
        'zh-TW': '客場數據',
        en: 'Away Stats',
      },
      HOME_STATS: {
        'zh-TW': '主場數據',
        en: 'Home Stats',
      },
      PLATFORM_ADMIN_ONLY: {
        'zh-TW': 'Rebas 管理員專用',
        en: 'Platform Admin Only',
      },
      ORG_G66N_ONLY: {
        'zh-TW': '雙和 管理員專用',
      },
    },
    SEQ: {
      'zh-TW': '比賽編號',
      en: 'Game Seq',
    },
    GROUP: {
      'zh-TW': '分類',
      en: 'Group',
    },
    GROUP_NONE: {
      'zh-TW': '未分類',
      en: 'UnGrouped',
    },
    AWAY: {
      'zh-TW': '客場',
      en: 'Away',
    },
    HOME: {
      'zh-TW': '主場',
      en: 'Home',
    },
    TEAM_NONE: {
      'zh-TW': '未定',
      en: 'UnConfirmed',
    },
    SCHEDULED_START_AT: {
      'zh-TW': '預計開始',
      en: 'Scheduled Start',
    },
    STARTED_AT: {
      'zh-TW': '開始時間',
      en: 'Started At',
    },
    ENDED_AT: {
      'zh-TW': '結束時間',
      en: 'Ended At',
    },
    STATUS: {
      WORDING: {
        'zh-TW': '狀態',
        en: 'Status',
      },
      SCHEDULED: {
        'zh-TW': '未賽',
        en: 'Scheduled',
      },
      PLAYING: {
        'zh-TW': '進行中',
        en: 'Playing',
      },
      FINISHED: {
        'zh-TW': '完賽',
        en: 'Finished',
      },
      SUSPENDED: {
        'zh-TW': '保留',
      },
      POSTPONED: {
        'zh-TW': '延賽',
        en: 'Postponed',
      },
    },
    FINISHED_STATUS: {
      WORDING: {
        'zh-TW': '完賽狀態',
        en: 'Finished Status',
      },
      CALLED: {
        'zh-TW': '提前結束',
        en: 'Called',
      },
      FORFEITED: {
        'zh-TW': '棄權',
        en: 'Forfeited',
      },
      ADJUDGED: {
        'zh-TW': '裁定',
        en: 'Adjudged',
      },
      SUSPENDED: {
        'zh-TW': '保留',
        en: 'Suspended',
      },
      NORMAL: {
        'zh-TW': '正常',
        en: 'Normal',
      },
    },
    MATCH_RESULT: {
      WORDING: {
        'zh-TW': '勝負',
        en: 'Match Result',
      },
      WIN: {
        'zh-TW': '勝',
        en: 'Win',
      },
      LOSE: {
        'zh-TW': '敗',
        en: 'Lose',
      },
      DRAW: {
        'zh-TW': '和',
        en: 'Draw',
      },
    },
    LOCATION: {
      'zh-TW': '地點',
      en: 'Location',
    },
    LOCATION_NONE: {
      'zh-TW': '未定',
      en: 'UnConfirmed',
    },
    NEWS: {
      WORDING: {
        'zh-TW': '報導',
        en: 'News',
      },
      TITLE: {
        'zh-TW': '標題',
        en: 'Title',
      },
      CONTENT: {
        'zh-TW': '內文',
        en: 'Content',
      },
      AUTHOR: {
        'zh-TW': '主編',
        en: 'Author',
      },
      CITY: {
        'zh-TW': '城市',
        en: 'City',
      },
      INTERVIEWER: {
        'zh-TW': '採訪',
        en: 'interviewer',
      },
      PHOTOGRAPHER: {
        'zh-TW': '攝影',
        en: 'photographer',
      },
    },
    MEDIA: {
      'zh-TW': '花絮',
      en: 'Media',
    },
    RELATED_LINKS: {
      WORDING: {
        'zh-TW': '相關連結',
        en: 'Related Links',
      },
      TITLE: {
        'zh-TW': '標題',
        en: 'Title',
      },
      LINK: {
        'zh-TW': '連結',
        en: 'Link',
      },
    },
    STATS_COMPLETENESS: {
      WORDING: {
        'zh-TW': '數據完整度',
        en: 'Stats Completeness',
      },
      NONE: {
        'zh-TW': '無',
        en: 'None',
      },
      BOX: {
        'zh-TW': 'Box Score',
        en: 'Box Score',
      },
      PBP: {
        'zh-TW': '逐打席',
        en: 'Per PA',
      },
      PITCH: {
        'zh-TW': '逐球',
        en: 'Per Ball',
      },
      EXPORT_EXCEL: {
        'zh-TW': '匯出 Box Score Excel',
        en: 'Export Box Score Excel',
      },
    },
    STATS_STATUS: {
      WORDING: {
        'zh-TW': '數據狀態',
        en: 'Stats Status',
      },
      NONE: {
        'zh-TW': '-',
      },
      NORMAL: {
        'zh-TW': '正常',
      },
      PITCH_MISSING: {
        'zh-TW': '有缺（落點等）',
      },
      CRITICAL: {
        'zh-TW': '錯誤！成績不相符',
      },
    },
    DATA_EXPORT: {
      WORDING: {
        'zh-TW': '資料匯出',
        en: 'Data Export',
      },
      PBP: {
        'zh-TW': '逐球資料',
        en: 'Pitch by Pitch',
      },
    },
    SCORE_BOARD: {
      'zh-TW': '計分板',
      en: 'Score Board',
    },
    SCORE: {
      'zh-TW': '得分',
      en: 'Score',
    },
    INNINGS: {
      'zh-TW': '局數',
      en: 'Innings',
    },
    HITS: {
      'zh-TW': '安打',
      en: 'Hits',
    },
    FLAG: {
      RUNS_WITHOUT_INNINGS: {
        'zh-TW': '設定局數',
        en: 'Set Innings',
      },
    },
    STATS: {
      RECORD: {
        WORDING: {
          'zh-TW': '紀錄',
          en: 'Record',
        },
        TYPE: {
          WORDING: {
            'zh-TW': '型態',
            en: 'Type',
          },
          BATTER: {
            'zh-TW': '打者',
            en: 'Batter',
          },
          PITCHER: {
            'zh-TW': '投手',
            en: 'Pitcher',
          },
        },
        PLAYER: {
          'zh-TW': '選手',
          en: 'Player',
        },
        VALUE: {
          WORDING: {
            'zh-TW': '內容',
            en: 'Content',
          },
          GWRBI: {
            'zh-TW': '勝利打點',
            en: 'GWRBI',
          },
          MVP: {
            'zh-TW': 'MVP',
            en: 'MVP',
          },
          SP_RECORD: {
            'zh-TW': '特殊紀錄',
            en: 'Special Record',
          },
          W: {
            'zh-TW': '勝投',
            en: 'W',
          },
          L: {
            'zh-TW': '敗投',
            en: 'L',
          },
          H: {
            'zh-TW': '中繼',
            en: 'H',
          },
          SV: {
            'zh-TW': '救援成功',
            en: 'SV',
          },
          BS: {
            'zh-TW': '救援失敗',
            en: 'BS',
          },
        },
        COMMENT: {
          'zh-TW': '備註',
          en: 'Comment',
        },
      },
      BATTING: {
        WORDING: {
          'zh-TW': '打擊成績',
          en: 'Batting Record',
        },
      },
      PITCHING: {
        WORDING: {
          'zh-TW': '投球成績',
          en: 'Pitching Record',
        },
      },
      FIELDING: {
        WORDING: {
          'zh-TW': '守備成績',
          en: 'Fielding Record',
        },
      },
    },
  },
  TOURNAMENT: {
    SIDEBAR: {
      BASIC: {
        'zh-TW': '基本資料',
        en: 'Basic Info',
      },
      STATS: {
        'zh-TW': '統計數據',
        en: 'Stats',
      },
      SCHEDULE: {
        'zh-TW': '賽程管理',
        en: 'Schedule',
      },
      GAME_GROUP: {
        'zh-TW': '比賽分類',
        en: 'Match Group',
      },
      GAME: {
        'zh-TW': '比賽',
        en: 'Match',
      },
      TEAMS: {
        'zh-TW': '球隊列表',
        en: 'Team List',
      },
      PLUGINS: {
        'zh-TW': '擴充套件',
        en: 'Plugins',
      },
      REGISTRATION: {
        'zh-TW': '報名系統',
        en: 'Registration',
      },
      PLATFORM_ADMIN_ONLY: {
        'zh-TW': 'Rebas 管理員專用',
        en: 'Platform Admin Only',
      },
      FORMAL_ADMIN_ONLY: {
        'zh-TW': 'Rebas 管理員專用',
        en: 'Formal Admin Only',
      },
      CPBL_MERGE: {
        'zh-TW': 'CPBL 球員合併',
      },
    },
    TITLE: {
      'zh-TW': '賽事名稱',
      en: 'Tournament Title',
    },
    TYPE: {
      'zh-TW': '賽事型態',
      en: 'Tournament Type',
    },
    TYPE_CUP_MATCHES: {
      'zh-TW': '盃賽（錦標賽）',
      en: 'Cups(Tournament)',
    },
    TYPE_LEAGUE_MATCHES: {
      'zh-TW': '聯賽',
      en: 'League',
    },
    TYPE_SPRING_TRAINING: {
      'zh-TW': '春訓（熱身）',
      en: 'Spring Training',
    },
    TYPE_CHALLENGE: {
      'zh-TW': '挑戰賽',
      en: 'Challenge',
    },
    TYPE_ALL_STAR: {
      'zh-TW': '明星賽',
      en: 'All Star',
    },
    TYPE_POSTSEASON: {
      'zh-TW': '季後賽',
      en: 'Postseason',
    },
    TYPE_OTHER: {
      'zh-TW': '其他',
      en: 'Other',
    },
    TYPE_NONE: {
      'zh-TW': '未設定',
      en: 'NONE',
    },
    TEAM_TYPE: {
      WORDING: {
        'zh-TW': '球隊要求',
        en: 'Team Requirement',
      },
      UNDER_ELEMENTARY_SCHOOL: {
        'zh-TW': '國小以下',
        en: 'Under Elementary School',
      },
      ELEMENTARY_SCHOOL: {
        'zh-TW': '國小',
        en: 'Elementary School',
      },
      JUNIOR_HIGH_SCHOOL: {
        'zh-TW': '國中',
        en: 'Junior High School',
      },
      SENIOR_HIGH_SCHOOL: {
        'zh-TW': '高中',
        en: 'Senior High School',
      },
      COLLEGE: {
        'zh-TW': '大學',
        en: 'College',
      },
      PROFESSION: {
        'zh-TW': '職業',
        en: 'Profession',
      },
      SOCIETY: {
        'zh-TW': '社會人',
        en: 'Member of Society',
      },
      NONE: {
        'zh-TW': '不設限',
        en: 'None',
      },
      OTHER: {
        'zh-TW': '其他',
        en: 'Other',
      },
    },
    PLAYER_TYPE: {
      WORDING: {
        'zh-TW': '球員要求',
        en: 'Player Requirement',
      },
      NONE: {
        'zh-TW': '不設限',
        en: 'None',
      },
      WOMEN: {
        'zh-TW': '女子',
        en: 'Women',
      },
      MEN: {
        'zh-TW': '男子',
        en: 'Men',
      },
    },
    BALL_TYPE: {
      WORDING: {
        'zh-TW': '比賽用球',
        en: 'Ball Using',
      },
      ORDINARY: {
        'zh-TW': '硬式',
        en: 'Ordinary',
      },
      RUBBER: {
        'zh-TW': '軟式',
        en: 'Rubber',
      },
    },
    BAT_TYPE: {
      WORDING: {
        'zh-TW': '球棒要求',
        en: 'Bat Requirement',
      },
      WOODEN: {
        'zh-TW': '木棒',
        en: 'Wooden',
      },
      METAL: {
        'zh-TW': '鋁棒',
        en: 'Metal',
      },
      NONE: {
        'zh-TW': '不設限',
        en: 'None',
      },
    },
    DATES: {
      'zh-TW': '賽事期間',
      en: 'Tournament Dates',
    },
    AUTO_GAME_SEQ_DESCRIPTION: {
      'zh-TW': '比賽編號由系統依照分類、日期自動編排（建議正式開打後關閉）',
      en: 'System auto assign game seq',
    },
    SEASON_LOCATION: {
      'zh-TW': '使用球場',
      en: 'Using Fields',
    },
    SEASON_LOCATION_DESCRIPTION: {
      'zh-TW': '如沒有欲使用的球場請與我們聯繫',
      en: 'Please contact us if your expected field is not on the list',
    },
    ROUND_ROBIN_POINT: {
      'zh-TW': '循環賽積分',
      en: 'Round Robin Point',
    },
    LEADERBOARD: {
      'zh-TW': '排行榜',
      en: 'Leaderboard',
    },
    PAWeight: {
      'zh-TW': '打者規定打席。使用預設請填 -1（1.9）',
      en: 'Batter Min PA Requirement',
    },
    IPWeight: {
      'zh-TW': '投手規定局數。使用預設請填 -1（0.8）',
      en: 'Pitcher Min IP Requirement',
    },
    OPEN_LEADERBOARD: {
      'zh-TW': '顯示排行榜',
      en: 'Display Leaderboard',
    },
    FIRST_GAME: {
      'zh-TW': '首場',
      en: 'First Game',
    },
    LAST_GAME: {
      'zh-TW': '終場',
      en: 'Last Game',
    },
    FILTER: {
      'zh-TW': '篩選比賽',
      en: 'Game Filter',
    },
    GAME_GROUP: {
      'zh-TW': '分類',
      en: 'Group',
    },
    GAME_GROUP_NONE: {
      'zh-TW': '未分類',
      en: 'Ungrouped',
    },
    GAME_LOCATION: {
      'zh-TW': '場地',
      en: 'Location',
    },
    GAME_SELECT_ALL: {
      'zh-TW': '全選',
      en: 'ALL',
    },
    GAME_GROUP_NAME: {
      'zh-TW': '分類名稱',
      en: 'Group Name',
    },
    GAME_GROUP_PRIORITY: {
      'zh-TW': '開打順序',
      en: 'Starting Priority',
    },
    GAME_GROUP_PRIORITY_FIRST: {
      'zh-TW': '首位',
      en: 'First',
    },
    GAME_GROUP_PRIORITY_AFTER_X: {
      'zh-TW': '之後',
      en: 'After',
    },
    GAME_GROUP_PREV_GROUPS: {
      'zh-TW': '前一階段',
      en: 'Previous Groups',
    },
    GAME_GROUP_NEXT_GROUPS: {
      'zh-TW': '晉級後階段',
      en: 'Next Groups',
    },
    GAME_GROUP_ESTIMATED_DURATION: {
      'zh-TW': '預計時間',
      en: 'Estimated Duration',
    },
    GAME_DATE_TIME_HINT: {
      'zh-TW': '請以 yyyy/MM/dd HH:mm 格式填寫',
      en: 'Please follow yyyy/MM/dd HH:mm format',
    },
    GAME_GROUP_SINGLE_ELIMINATION: {
      'zh-TW': '單敗淘汰',
      en: 'Single Elimination',
    },
    GAME_GROUP_STANDINGS_DISPLAY: {
      'zh-TW': '戰績排行顯示',
      en: 'Standings Display',
    },
    SCHEDULE_DISPLAY_MODE: {
      'zh-TW': '顯示模式',
      en: 'Display Mode',
    },
    LOCATION: {
      'zh-TW': '地點',
      en: 'Location',
    },
    DATE_RANGE: {
      'zh-TW': '日期範圍',
      en: 'Date Range',
    },
    GAME_DELETE_HINT: {
      'zh-TW': '輸入比賽編號後再次點擊刪除',
      en: 'Click Delete again after typed Game Seq',
    },
    TEAM_AMOUNT: {
      'zh-TW': '隊伍數',
      en: 'Team Amount',
    },
    IMPORT_FROM_TOURNAMENT: {
      WORDING: {
        'zh-TW': '從歷史賽事導入',
        en: 'Import from History Tournaments',
      },
      NO_OTHER_TOURNAMENTS: {
        'zh-TW': '您目前僅擁有此賽事',
        en: 'You have current tournament only',
      },
      INCLUDE_PLAYERS: {
        'zh-TW': '同時匯入球員',
        en: 'Import players at the same time',
      },
      TEAM_NAME_DUPLICATE: {
        'zh-TW': '已有同名球隊',
        en: 'Team name is duplicate',
      },
      IMPORT: {
        'zh-TW': '導入',
        en: 'Import',
      },
    },
    ERROR: {
      UNKNOWN: {
        'zh-TW': '發生錯誤，請稍後再試',
        en: 'Oops, something wrong. Please try again later.',
      },
      TITLE: {
        'zh-TW': '賽事名稱格式錯誤（不得為空、避免特殊符號）',
        en: 'Invalid tournament title(required, avoid special character)',
      },
      DATES: {
        'zh-TW': '無效賽事期間',
        en: 'Invalid tournament dates',
      },
      LEADERBOARD_WEIGHT: {
        'zh-TW': '投打規定打席數字無效',
        en: 'Invalid PA/IP requirement number',
      },
      ROUND_ROBIN_POINT: {
        'zh-TW': '循環賽積分應為整數',
        en: 'Round Robin Point should be integer',
      },
      TEAM_ALREADY_JOINED_GAMES: {
        'zh-TW': '球隊已參與比賽，不得註銷',
        en: 'Team has already joined games',
      },
      GAME_GROUP_NAME: {
        'zh-TW': '分類名稱格式錯誤（不得為空、避免特殊符號與 NEW NONE NULL 等專用詞）',
        en: 'Invalid group name(required, avoid special character or NEW, NONE, NULL...)',
      },
      GAME_GROUP_NAME_DUPLICATE: {
        'zh-TW': '分類名稱重複',
        en: 'Duplicate Group Name',
      },
      GAME_DATE_TIME_HINT: {
        'zh-TW': '時間日期請以 yyyy/MM/dd HH:mm 格式填寫',
        en: 'Date Time please follow yyyy/MM/dd HH:mm format',
      },
      GAME_FINISHED_STATUS: {
        'zh-TW': '完賽需提供完賽狀態',
        en: 'Finished match should provide finished status',
      },
      GAME_SEQ_FORMAT: {
        'zh-TW': '比賽編號需為正整數',
        en: 'Match seq has to be positive int',
      },
      GAME_SEQ_DUPLICATE: {
        'zh-TW': '比賽編號不得與現有比賽重複',
        en: 'Match seq is duplicated',
      },
      GAME_NON_SCHEDULED_NO_TEAM: {
        'zh-TW': '非 未賽 比賽需指定主客場隊伍',
        en: 'Non scheduled match need specific teams',
      },
      GAME_NON_SCHEDULED_NO_LOCATION: {
        'zh-TW': '非 未賽 比賽需指定地點',
        en: 'Non scheduled match need specific location',
      },
      GAME_SCORE_FORMAT: {
        'zh-TW': '比賽分數需為 0 或正整數',
        en: 'Match score has to be zero or positive int',
      },
      GAME_HITS_FORMAT: {
        'zh-TW': '安打數需為 0 或正整數',
        en: 'Hits has to be zero or positive int',
      },
      GAME_NEWS_REQUIREMENT: {
        'zh-TW': '標題、照片與內文為必填欄位',
        en: 'Title, cover and content are required',
      },
      GAME_INNING_FORMAT: {
        'zh-TW': '比賽局數需為正整數',
        en: 'Match innings has to be positive int',
      },
      GAME_TEAM_INNING_FORMAT: {
        'zh-TW': '球隊逐局分數格式錯誤，請參考說明',
        en: "Team's per innings score is invalid, please follow the description",
      },
      GAME_STATS_SELECT: {
        'zh-TW': '所有下拉選單皆為必選項目',
        en: 'All selections are required',
      },
      GAME_STATS_SP_RECORD_EMPTY_COMMENT: {
        'zh-TW': '特殊紀錄請增加備註',
        en: 'Please comment for special record',
      },
      GAME_STATS_BATTER_ORDER: {
        'zh-TW': '打序需為正整數',
        en: 'Batter order should be positive int',
      },
      GAME_STATS_BATTER_COLUMN_INT: {
        'zh-TW': '打者數據應皆為零或正整數',
        en: "All the batter's column should be zero or positive int",
      },
      GAME_STATS_PITCHER_COLUMN_INT: {
        'zh-TW': '投手數據應皆為零或正整數',
        en: "All the pitcher's column should be zero or positive int",
      },
      GAME_STATS_FIELDING_COLUMN_INT: {
        'zh-TW': '守備數據應皆為零或正整數',
        en: "All the fielding's column should be zero or positive int",
      },
    },
    SUCCESS: {
      UPDATE: {
        'zh-TW': '更新成功',
        en: 'update successfully',
      },
    },
    CREATE_GAME: {
      'zh-TW': '新增比賽',
      en: 'Create Match',
    },
    CALENDAR_CREATE_GAME_HINT: {
      'zh-TW': '點擊日期可新增比賽',
      en: 'Click string of date can create match',
    },
    MEDIA_UPLOAD: {
      'zh-TW': '接受 < 5MB 圖片檔',
      en: 'Accept image before 5MB',
    },
    MEDIA_UPLOAD_DESCRIPTION: {
      'zh-TW': `每場比賽接受六張圖片，建議上傳 png/jpg/jpeg 檔以確保各裝置皆能正常瀏覽。
      影片不得大於 25MB，如果大型影片建議上傳至 Youtube 後使用相關連結儲存。`,
      en: `Allow six images for each match. Suggest png/jpg/jpeg ext file for better experience.
      Video can not larger then 25MB. Upload to Youtube then use related links for large size video.`,
    },
    MEDIA_UPLOAD_PREMIUM_DESCRIPTION: {
      'zh-TW': `每場比賽接受五十張圖片，建議上傳 png/jpg/jpeg 檔以確保各裝置皆能正常瀏覽。
      影片不得大於 25MB，如果大型影片建議上傳至 Youtube 後使用相關連結儲存。`,
      en: `Allow fifty images for each match. Suggest png/jpg/jpeg ext file for better experience.
      Video can not larger then 25MB. Upload to Youtube then use related links for large size video.`,
    },
    NEWS_DESCRIPTION: {
      'zh-TW': '圖片建議使用長寬比為 4:3 之 png/jpg/jpeg 檔',
      en: 'Suggest using 4:3 ratio png/jpg/jpeg ext file for cover image',
    },
    RELATED_LINKS_DESCRIPTION: {
      'zh-TW': '僅限 https:// 開頭之連結',
      en: 'Link should start with https://',
    },
    SCORE_BOARD_TEAM_DISABLE_DESCRIPTION: {
      'zh-TW': '由於已上傳 Box Score 數據，球隊不得由此更改',
      en: 'According to uploaded Box Score Stats, team is not avaliable to edit here.',
    },
    SCORE_BOARD_INNINGS_DESCRIPTION: {
      'zh-TW': '逐局請以 "," 作為區隔，每局接受 數字、數據x（該局未結束）、-（該局未開始）',
      en:
        'Use "," to seperate per inning. Each inning allow number, number with x append(non finished inning), -(non started inning)',
    },
    SCORE_BOARD_INNINGS_DESCRIPTION_EXAMPLE: {
      'zh-TW': '舉例：0,0,0,1,2 | 2,0,0,0,3x | 1,0,2,0,-',
      en: 'For Example: 0,0,0,1,2 | 2,0,0,0,3x | 1,0,2,0,-',
    },
    SCORE_BOARD_HITS_DISABLE_DESCRIPTION: {
      'zh-TW': '由於已上傳打擊 Box Score，安打總和將連動數據不予自行修改',
      en: 'According to uploaded Batting Box Score, sum of hits is not avaliable to edit here.',
    },
    STATS_DESCRIPTION: {
      'zh-TW': '現階段僅提供上傳選手紀錄與成績，如有上傳逐打席數據之需求請提供完整紀錄單供我方協助處理。',
      en: 'Please contact us if you have per PA records upload requirement.',
    },
    STATS_PBP_UPLOADED_HINT: {
      'zh-TW':
        '已成功上傳逐打席數據！注意！如更改 Box Score，逐打席數據不會連動，投手增減可能導致 FirstBase 數據錯誤！',
      en:
        'Per PA records uploaded! Warning! Adjust Box Score will not change per PA record, but pitcher add/remove might cause FirstBase stats error',
    },
    PLUGIN: {
      OPEN_REGISTRATION: {
        'zh-TW': '報名系統',
        en: 'Registration',
      },
      OPEN_REGISTRATION_DESCRIPTION: {
        'zh-TW': `開放球隊線上報名，不再需要辛苦 key in 球員資料、線上審核、秩序冊製作、報名費收款一手包辦！
        協助您將事前準備電子化，不再需要堆疊成山的紙本文件，系統化的資料協助您節省時間與人力成本。`,
        en: `We have covered Online Review, Program Doc Auto Generate, Receive Registry Fee Payment.
        More than that, the registry team will upload players info, no longer require key in data yourself!`,
      },
      EXPAND_MEDIA_SPACE: {
        'zh-TW': '逐場花絮擴充',
        en: 'Expand Media Space',
      },
      EXPAND_MEDIA_SPACE_DESCRIPTION: {
        'zh-TW': `每場比賽可上傳最多 50 張照片（整個賽事不超過 5,000 張）`,
        en: 'Allow to upload up to 50 photos per game.(Maximum 5,000 photos in a tournament)',
      },
      PAPER_RECORD_ONLINE: {
        'zh-TW': '紙本紀錄上傳',
        en: 'Support uploading paper game record',
      },
      PAPER_RECORD_ONLINE_DESCRIPTION: {
        'zh-TW': `預付金，我方將優先協助。實際價格我們將與您依狀況討論。
        依照賽事現有紀錄狀況，提供將紙本紀錄轉換為電子紀錄的服務。`,
        en: `Advance payment, we will provide actual amount after discussing with your situation.
        Consider to the paper recording situation in the tournament, we can help you transform and upload the data into platform.`,
      },
      PAPER_RECORD_ONLINE_DESCRIPTION_SHORT: {
        'zh-TW': `依照賽事現有紀錄狀況，提供將紙本紀錄轉換為電子紀錄的服務。`,
        en: `Consider to the paper recording situation in the tournament, we can help you transform and upload the data into platform.`,
      },
      OFFLINE_COMMISSIONER: {
        'zh-TW': '賽事現場合作',
        en: 'Offline Commissioner',
      },
      OFFLINE_COMMISSIONER_DESCRIPTION: {
        'zh-TW': `預付金，我方將優先協助。實際價格我們將與您依狀況討論。
        我們提供現場攝影、報導、簡易直播等服務，如有上述或其他相關需求歡迎與我們討論。`,
        en: `Advance payment, we will provide actual amount after discussing with your situation.
        Providing photographer, reporter or basic stream live... etc.
        We are willing to cooperate with you if there are any above or related demands`,
      },
      OFFLINE_COMMISSIONER_DESCRIPTION_SHORT: {
        'zh-TW': `我們提供現場攝影、報導、簡易直播等服務，如有上述或其他相關需求歡迎與我們討論。`,
        en: `Providing photographer, reporter or basic stream live... etc.
        We are willing to cooperate with you if there are any above or related demands`,
      },
      SELECT_ANY_DESCRIPTION: {
        'zh-TW': `如您欲使用 ATM 轉帳或現金付款請取消勾選並與我們聯絡，我們將於收到款項後協助開啟相關功能。`,
        en: `If you prefer using ATM or cash as payment method, please cancel the selection and contact us directly.
        We will manually open the service after the deal.`,
      },
      SELECT_ANY_TMP_DESCRIPTION: {
        'zh-TW': `現階段尚未開啟線上付款服務。創建後我們將與您聯絡，並於收到款項後協助開啟相關功能。`,
        en: `Sorry, the online payment is unavaliable currently.
        We will contact you after the creation and manually open the service after the deal.`,
      },
      SELECT_NOTHING_DESCRIPTION: {
        'zh-TW': `所有套件皆能日後購買，如對於加購內容有疑問歡迎與我們聯絡！`,
        en: `You can purchase those plugins anytime. Feel free to contact us if you have any questions!`,
      },
      CONVINCE_IN_MANAGEMENT: {
        'zh-TW': `如欲購買套件或對已加購內容有疑問歡迎與我們聯絡！`,
        en: `Feel free to contact us if you want to use any plugins or question on purchased content!`,
      },
    },
  },
  CALENDAR: {
    WORDING: {
      'zh-TW': '日曆',
      en: 'Calendar',
    },
    SUNDAY: {
      'zh-TW': '週日',
      en: 'Sunday',
    },
    MONDAY: {
      'zh-TW': '週一',
      en: 'Monday',
    },
    TUESDAY: {
      'zh-TW': '週二',
      en: 'Tuesday',
    },
    WEDNESDAY: {
      'zh-TW': '週三',
      en: 'Wednesday',
    },
    THURSDAY: {
      'zh-TW': '週四',
      en: 'Thursday',
    },
    FRIDAY: {
      'zh-TW': '週五',
      en: 'Friday',
    },
    SATURDAY: {
      'zh-TW': '週六',
      en: 'Saturday',
    },
    CURRENT_MONTH: {
      'zh-TW': '本月',
      en: 'Current Month',
    },
    COLLAPSE: {
      'zh-TW': '展開',
      en: 'Collapse',
    },
  },
  STATS: {
    BATTER: {
      PLAYER: {
        'zh-TW': '選手',
        en: 'Player',
      },
      IS_PH: {
        'zh-TW': '替補',
        en: 'Pinch',
      },
      ORDER: {
        'zh-TW': '打序',
        en: 'Order',
      },
      PA: {
        'zh-TW': '打席',
        en: 'PA',
      },
      AB: {
        'zh-TW': '打數',
        en: 'AB',
      },
      H: {
        'zh-TW': '安打',
        en: 'H',
      },
      TWOB: {
        'zh-TW': '二壘安打',
        en: '2B',
      },
      THREEB: {
        'zh-TW': '三壘安打',
        en: '3B',
      },
      HR: {
        'zh-TW': '全壘打',
        en: 'HR',
      },
      SO: {
        'zh-TW': '三振',
        en: 'SO',
      },
      BB: {
        'zh-TW': '四壞',
        en: 'BB',
      },
      IBB: {
        'zh-TW': '故意四壞',
        en: 'IBB',
      },
      HBP: {
        'zh-TW': '觸身球',
        en: 'HBP',
      },
      SF: {
        'zh-TW': '犧牲飛球',
        en: 'SF',
      },
      SH: {
        'zh-TW': '犧牲觸擊',
        en: 'SH',
      },
      GIDP: {
        'zh-TW': '滾地雙殺',
        en: 'GIDP',
      },
      FC: {
        'zh-TW': '野手選擇',
        en: 'FC',
      },
      E: {
        'zh-TW': '失誤上壘',
        en: 'E',
      },
      FO: {
        'zh-TW': '飛球出局',
        en: 'FO',
      },
      GO: {
        'zh-TW': '滾地出局',
        en: 'GO',
      },
      SB: {
        'zh-TW': '盜壘成功',
        en: 'SB',
      },
      CS: {
        'zh-TW': '盜壘失敗',
        en: 'CS',
      },
      R: {
        'zh-TW': '得分',
        en: 'R',
      },
      RBI: {
        'zh-TW': '打點',
        en: 'RBI',
      },
    },
    PITCHER: {
      PLAYER: {
        'zh-TW': '選手',
        en: 'Player',
      },
      ORDER: {
        'zh-TW': '順序',
        en: 'Order',
      },
      IPOUT: {
        'zh-TW': '出局',
        en: 'Outs',
      },
      NP: {
        'zh-TW': '投球',
        en: 'NP',
      },
      BF: {
        'zh-TW': '打席',
        en: 'BF',
      },
      H: {
        'zh-TW': '安打',
        en: 'H',
      },
      HR: {
        'zh-TW': '全壘打',
        en: 'HR',
      },
      BB: {
        'zh-TW': '四壞',
        en: 'BB',
      },
      IBB: {
        'zh-TW': '故意四壞',
        en: 'IBB',
      },
      HB: {
        'zh-TW': '觸身',
        en: 'HB',
      },
      SO: {
        'zh-TW': '三振',
        en: 'SO',
      },
      WP: {
        'zh-TW': '暴投',
        en: 'WP',
      },
      BK: {
        'zh-TW': '投手犯規',
        en: 'BK',
      },
      R: {
        'zh-TW': '失分',
        en: 'R',
      },
      ER: {
        'zh-TW': '責失',
        en: 'ER',
      },
    },
    FIELDER: {
      PLAYER: {
        'zh-TW': '選手',
        en: 'Player',
      },
      ORDER: {
        'zh-TW': '順序',
        en: 'Order',
      },
      POSITION: {
        'zh-TW': '守位',
        en: 'Position',
      },
      TC: {
        'zh-TW': '守備機會',
        en: 'TC',
      },
      PO: {
        'zh-TW': '刺殺',
        en: 'PO',
      },
      A: {
        'zh-TW': '助殺',
        en: 'A',
      },
      E: {
        'zh-TW': '失誤',
        en: 'E',
      },
      DP: {
        'zh-TW': '雙殺',
        en: 'DP',
      },
      PB: {
        'zh-TW': '捕逸',
        en: 'PB',
      },
      SB: {
        'zh-TW': '被盜壘',
        en: 'SB',
      },
      CS: {
        'zh-TW': '盜壘阻殺',
        en: 'CS',
      },
    },
    POSITION: {
      P: {
        'zh-TW': '投',
        en: 'P',
      },
      C: {
        'zh-TW': '捕',
        en: 'C',
      },
      '1B': {
        'zh-TW': '一壘',
        en: '1B',
      },
      '2B': {
        'zh-TW': '二壘',
        en: '2B',
      },
      '3B': {
        'zh-TW': '三壘',
        en: '3B',
      },
      SS: {
        'zh-TW': '游擊',
        en: 'SS',
      },
      LF: {
        'zh-TW': '左外野',
        en: 'LF',
      },
      CF: {
        'zh-TW': '中外野',
        en: 'CF',
      },
      RF: {
        'zh-TW': '右外野',
        en: 'RF',
      },
      DH: {
        'zh-TW': '指定打擊',
        en: 'DH',
      },
      PH: {
        'zh-TW': '代打',
        en: 'PH',
      },
      PR: {
        'zh-TW': '代跑',
        en: 'PR',
      },
    },
  },
  ACCOUNT_MANAGEMENT: {
    WORDING: {
      'zh-TW': '帳戶管理',
      en: 'Account Management',
    },
  },
};

const Multilingual = (textCode, additionalTextMapping = {}, lang = '') => {
  // TODO 拿 localStorage 自主設定
  const userDefaultLangs = [lang, ...navigator.languages];

  const textCodeIndent = textCode.split('.');

  let target = { ...textMapping, ...additionalTextMapping };
  textCodeIndent.forEach((key) => {
    if (!target[key]) {
      console.log(target);
      console.log(key);
      throw new Error();
    }

    target = target[key];
  });

  // 2024/07/11 由於翻譯資料不完整，先回傳繁體中文以求網站語系統一
  return target['zh-TW'];
  for (let userLang of userDefaultLangs) {
    if (!target[userLang]) {
      continue;
    }

    return target[userLang];
  }
  return target['zh-TW'];
};

export default Multilingual;
